import produce from 'immer'
import { SET_LOCALE } from './constants'

const initialState = {
  locale: 'en',
}

const reducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case SET_LOCALE:
        draft.locale = action.locale
        break
      default:
        break
    }
  })

export default reducer
